var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.mode == 'overlay' ? _c('v-overlay', {
    attrs: {
      "absolute": ""
    },
    model: {
      value: _vm.shows,
      callback: function ($$v) {
        _vm.shows = $$v;
      },
      expression: "shows"
    }
  }, [_c('v-card', {
    staticClass: "d-flex flex-column align-center",
    attrs: {
      "flat": "",
      "rounded": "xl",
      "color": "primary"
    },
    on: {
      "click": _vm.open
    }
  }, [_c('v-icon', {
    attrs: {
      "size": "240"
    }
  }, [_vm._v("mdi-file-upload")]), _c('v-card-title', [_vm._v("계약서 양식 문서를 업로드해주세요")]), _c('v-file-input', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: false,
      expression: "false"
    }],
    ref: "v-file-input",
    on: {
      "change": _vm.emit
    },
    model: {
      value: _vm.file,
      callback: function ($$v) {
        _vm.file = $$v;
      },
      expression: "file"
    }
  })], 1)], 1) : _vm.mode == 'button' ? _c('v-btn', {
    attrs: {
      "small": "",
      "text": "",
      "icon": ""
    },
    on: {
      "click": _vm.open
    }
  }, [_c('v-icon', [_vm._v("mdi-file-upload-outline")]), _c('v-file-input', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: false,
      expression: "false"
    }],
    ref: "v-file-input",
    on: {
      "change": _vm.emit
    },
    model: {
      value: _vm.file,
      callback: function ($$v) {
        _vm.file = $$v;
      },
      expression: "file"
    }
  })], 1) : _vm._e();

}
var staticRenderFns = []

export { render, staticRenderFns }